import { useReactiveVar } from '@apollo/client'
import { workspaceSelectedElement } from 'api/graphQL/reactiveVars/element'
import { useMemo } from 'react'

/**
 * Hook for managing editing permissions based on added to project.
 * Centralizes all security checks for edit operations.
 */
export const useEditingPermissions = () => {
    const { selectedElementNode } = useReactiveVar(workspaceSelectedElement)

    return useMemo(
        () => ({
            canEdit: selectedElementNode?.isInProject ?? false,
        }),
        [selectedElementNode?.isInProject]
    )
}
